module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.$t('app_newdvtype')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "typeName",
      "label": _vm.$t('app_typeName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.label_type')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogFormVisible),
      callback: function($$v) {
        _vm.dialogFormVisible = $$v
      },
      expression: "dialogFormVisible"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_typeName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-544cf74b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/deviceTypeManage.vue
// module id = 1038
// module chunks = 0